import _defineProperty from "/buddy/kaporg-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

// =========================== Motion ===========================
var genRtlStyle = function genRtlStyle(token) {
  var componentCls = token.componentCls;
  return _defineProperty({}, "".concat(componentCls, "-rtl"), {
    direction: 'rtl'
  });
};

export default genRtlStyle;